// 🚀 Standardized Reward Tiers (More Difficult Over Time)
export const REWARD_TIERS = {
    25: "🎉 Extra Free Trade",
    50: "💰 Special Discount",
    100: "🏆 Super Sharer Badge",
    150: "🔥 VIP Trader Access",
    200: "🚀 Early Access to Features",
    500: "🎖️ Exclusive Partner Badge",
  };
  